import {PageTitle} from '../../_metronic/layout/core'
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import TabItem from '../../app/components/tabs/TabItem';
import OnboardingPage from "../../app/pages/onboarding/OnboardingPage";
import StickyYoutubePlayer from "../../components/StickyYoutubePlayer";

export function Profile() {
  const location = useLocation();
  const isSettings = location.pathname === '/profile/settings';

  return (
    <>
      <PageTitle description='Hesabınızı ve sınıfınızın başlangıç adımlarını takip edin.'>Profilim</PageTitle>
      <div className="profile-tabs card">
        <div className="tab-list">
          <TabItem
            title="Profiliniz"
            isActive={!isSettings}
            icon={<i className="fa fa-user"></i>}
            to="/profile"
          />
          <TabItem
            title="Ayarlar"
            isActive={isSettings}
            icon={<i className="fa fa-cog"></i>}
            to="/profile/settings"
          />
        </div>
      </div>

      <div className="tab-content">
        {!isSettings ? (
          <OnboardingPage />
        ) : (
          <div className="card">
            {/* Settings content will be here */}
          </div>
        )}
      </div>
        <StickyYoutubePlayer videoId={"s0pGZee8ygk"} time={"115"} />
    </>
  );
}
